<template>
  <module-configuration :data="config" :errors="errors" :useAuthentication="false">
    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>

        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>

        <form-group label="Tipo padrão" :columns="3" :required="isRequiredType">
          <select class="form-select" v-model="config.product.type">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option v-for="type in typeOptions" :key="type" :value="type">{{ $t(`mercadoLivre.types.${type}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="Tipo Envio" :columns="3" :required="isRequiredShippingMode">
          <select class="form-select" v-model="config.product.shippingMode">
            <option :value=null>{{ $t('choose.label') }}</option>
            <option v-for="type in shippingOptions" :key="type" :value="type">{{ $t(`mercadoLivre.shippingOptions.${type}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="Adicionar referência do produto no título do anúncio">
          <label class="form-switch">
            <input type="checkbox" v-model="config.product.appendReferenceCodeOnTitle">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">Define se ao final do título do anúncio devem ser adicionadas as referências do produto.</small>
        </form-group>

        <form-group label="Sincronização de preço customizado" :columns="3">
          <select class="form-select" v-model="config.product.synchronizePriceFromMercadoLivre">
            <option v-for="option in synchronizePriceFromMercadoLivreOptions" :key="option" :value="option">{{ $t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se o preço do anúncio pode ser alterado pelo Mercado Livre.</small>
          <small class="form-help">Caso essa configuração seja utilizada podem ocorrer divergências entre os preços do Placemarket e Mercado Livre.</small>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel title="Pedidos">
      <div class="l-row">
        <form-group label="Sincronizar pedidos com entrega Full" :columns="3">
          <select class="form-select" v-model="config.order.synchronizeFulfillment">
            <option v-for="option in synchronizeFulfillmentOptions" :key="option" :value="option">{{ $t(`${option}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="Salvar nota fiscal emitida pelo Mercado Livre" :columns="3">
          <select class="form-select" v-model="config.order.synchronizeOrderInvoice">
            <option v-for="option in synchronizeOrderInvoiceOptions" :key="option" :value="option">{{ $t(`${option}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="Sincronizar e atualizar pedidos" :columns="3">
          <select class="form-select" v-model="config.order.synchronizeOrders">
            <option v-for="option in synchronizeOrdersOptions" :key="option" :value="option">{{ $t(`mercadoLivre.synchronizeOrdersOptions.${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os pedidos serão sincronizados e atualizados.</small>
        </form-group>

        <order-retrieve-date-configuration :orderConfigs="config.order" :columns="6"/>

        <form-group label="Enviar XML de nota fiscal de pedidos para o Mercado Livre" :columns="3">
          <select class="form-select" v-model="config.order.sendInvoiceXmlToMercadoLivre">
            <option v-for="option in sendInvoiceXmlToMercadoLivreOptions" :key="option" :value="option">{{ $t(`${option}.label`) }}</option>
          </select>
        </form-group>
      </div>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados no Mercado Livre.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados no Mercado Livre.</small>
        </form-group>

        <form-group label="Sincronizar imagens" :columns="3">
          <select class="form-select" v-model="config.synchronize.images">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se as imagens serão sobescritas e reenviadas ao Marketplace caso ocorra atualização no Painel Ecommerce Moovin.</small>
        </form-group>
      </div>
    </panel>

    <panel title="Descrição dos anúncios">
      <div class="l-row">
        <form-group label="Descrição do Topo" :columns="12">
          <textarea
            class="form-textarea"
            rows="6"
            placeholder="Adicione a descrição que deve ficar acima da descrição do produto."
            v-model="config.product.description.header"></textarea>
        </form-group>
        <form-group label="Descrição do rodapé" :columns="12">
          <textarea
            class="form-textarea"
            rows="6"
            placeholder="Adicione a descrição que deve ficar abaixo da descrição do produto."
            v-model="config.product.description.footer"></textarea>
        </form-group>
      </div>
    </panel>
  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'mercadoLivre'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'mercadoLivre',
      typeOptions: [
        'gold_pro',
        'gold_special',
        'free'
      ],
      shippingOptions: [
        'me1',
        'me2',
        'custom',
        'not_specified'
      ],
      synchronizeFulfillmentOptions: [
        false,
        true
      ],
      synchronizePriceFromMercadoLivreOptions: [
        false,
        true
      ],
      synchronizeOrdersOptions: [
        'all',
        'none',
        'onlySynchronizedAnnouncement'
      ],
      sendInvoiceXmlToMercadoLivreOptions: [
        false,
        true
      ],
      synchronizeOptions: [
        true,
        false
      ],
      synchronizeOrderInvoiceOptions: [
        true,
        false
      ],
      config: {
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          },
          type: null,
          shippingMode: null,
          appendReferenceCodeOnTitle: false,
          synchronizePriceFromMercadoLivre: false,
          description: {
            header: '',
            footer: ''
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          synchronizeFulfillment: false,
          synchronizeOrders: null,
          retrieveDate: null,
          sendInvoiceXmlToMercadoLivre: false,
          synchronizeOrderInvoice: false
        },
        synchronize: {
          stock: true,
          price: true,
          images: false
        }
      }
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ]),
      isRequiredType () {
        return !this.config.product.type
      },
      isRequiredShippingMode () {
        return !this.config.product.shippingMode
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// MercadoLivre.vue?3272930a